import BenchmarkManager from "../benchmarkManager";
import * as benchmarkActions from "./benchmarkActions";

const obtemDadosBenchmarkUsuario = (IdUsuario) => async (dispatch) => {
  try {
    dispatch(benchmarkActions.setBenchmarkData({ carregando: true }));
    const associacoes =
      await BenchmarkManager.obtemAssociacoesUsuario(IdUsuario);
    dispatch(
      benchmarkActions.setBenchmarkData({
        associacoes,
        carregando: false,
      }),
    );
  } catch (error) {
    console.error("Erro ao obter dados de benchmark do usuário:", error);
    dispatch(benchmarkActions.setBenchmarkData({ carregando: false }));
  }
};

export { obtemDadosBenchmarkUsuario };
